import { fontSize } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from '../../../../styles/dggTheme';
import { breakpoint } from '../../../../styles/dontgiftguide.styles';

const { text, spacing } = dggTheme;

export const tile = css`
  margin: 0 ${pxToRem(spacing.sm)} ${pxToRem(spacing.xl)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: 450px;
      margin-bottom: ${pxToRem(spacing.xxxxl)};
    `,
  )}

  img {
    width: 100%;
    object-fit: cover;
    border-radius: ${pxToRem(30)};
    height: 150px;

    ${mediaQuery(
      { min: breakpoint },
      css`
        height: 450px;
      `,
    )}
  }

  a {
    display: block;
    color: inherit;
    text-decoration: none;
  }
`;

export const title = css`
  text-align: left;
  ${fontSize(text.BODY.SM)}
  font-size: ${pxToRem(text.BODY.SM.fontSize)};
  line-height: normal;

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(text.HEADING.MD.fontSize)};
    `,
  )}
`;
